/*!
 * Copyright (c) 2026 Elevation Technologies Pte Ltd.
 * Developer: filimoni@elevationtech.com.fj
 */
import React from 'react';

export default function PageLinks({ links = [] }) {
  const visibleLinks = links.filter((link) => link?.href && link?.label).slice(0, 12);

  if (!visibleLinks.length) {
    return null;
  }

  return (
    <aside className="fsf-side-card">
      <h2>Helpful Links</h2>
      <nav aria-label="Helpful links">
        {visibleLinks.map((link, index) => (
          <a key={`${link.href}-${index}`} href={link.href}>
            {link.label}
          </a>
        ))}
      </nav>
    </aside>
  );
}
